import Guidelines from "./Guidelines";

export default Guidelines;
